import React from "react";
import { Card } from "@mui/material";
import NotificationItem from "./NotificationItem";
import FavoriteIcon from "@mui/icons-material/Favorite";
import MuseumIcon from "@mui/icons-material/Museum";
import UpdateIcon from "@mui/icons-material/Update";

const notifications = [
  {
    icon: <FavoriteIcon color="primary" />,
    title: "서울형키즈카페 정릉3동점",
    description: "2025-01-03일 오픈되었습니다.",
    time: "5m ago"
  },
  {
    icon: <MuseumIcon color="secondary" />,
    title: "국립과학박물관",
    description: "2025-01-04일 오픈되었습니다.",
    time: "21m ago"
  },
  {
    icon: <UpdateIcon color="info" />,
    title: "Schedule Changed",
    description: "You have successfully changed your appointment with Dr. Joshua Doe.",
    time: "8h ago"
  }
];

const NotificationList = () => {
  return (
    <Card variant="outlined" sx={{borderRadius:2}}>
      {notifications.map((notif, index) => (
        <NotificationItem key={index} {...notif} />
      ))}
    </Card>
  );
};

export default NotificationList;
